import { missionIcons } from '@/config/images'

const missionsList = [
  {
    id: 1,
    title: 'Cyberbullying',
    icon: missionIcons.mission1,
    discription:
      'Learn to spot, stop, and report harmful online behaviors while supporting peers.',
    isLocked: false,
    headerClass: 'cyberbullying',
    pdfLocation: 'assets/pdf/mission1.pdf',
    classDiscussion:
      'gs://digipalz-10512.firebasestorage.app/discussion/discussion_mission1.pdf',
    activity: {
      title: 'Written Reflection ',
      description:
        'Write 2–3 sentences explaining what it means to be safe, kind, and brave online.'
    }
  },
  {
    id: 2,
    title: 'IP Addresses & Digital Footprints',
    icon: missionIcons.mission2,
    discription:
      'Discover how IP addresses and digital footprints track actions and shape reputation.',
    isLocked: false,
    headerClass: 'ip-digital',
    pdfLocation: 'assets/pdf/mission2.pdf',
    classDiscussion:
      'gs://digipalz-10512.firebasestorage.app/discussion/discussion_mission2.pdf',
    activity: {
      title: 'Written Reflection ',
      description:
        'Write 2–3 sentences explaining why it is important to think before you post online.'
    }
  },
  {
    id: 3,
    title: 'Passwords & Device Safety',
    icon: missionIcons.mission3,
    discription:
      'Practice strong password habits, device safety, and multi-factor authentication.',
    isLocked: false,
    headerClass: 'passwords',
    pdfLocation: 'assets/pdf/mission3.pdf',
    classDiscussion:
      'gs://digipalz-10512.firebasestorage.app/discussion/discussion_mission3.pdf',
    activity: {
      title: 'Password Lock Designer',
      description:
        'Draw a visual password lock and show the rules or features that make it strong and hard to break.'
    }
  },
  {
    id: 4,
    title: 'Personal & Private Information',
    icon: missionIcons.mission4,
    discription:
      'Explore safe sharing, geotags, and consent to protect privacy and respect boundaries.',
    isLocked: false,
    headerClass: 'info-identity',
    pdfLocation: 'assets/pdf/mission4.pdf',
    classDiscussion:
      'gs://digipalz-10512.firebasestorage.app/discussion/discussion_mission4.pdf',
    activity: {
      title: 'Digital Privacy Defender',
      description:
        'Design a superhero who protects digital privacy and show what they defend and how they keep information safe.'
    }
  },
  {
    id: 5,
    title: 'Identity Theft & Phishing',
    icon: missionIcons.mission5,
    discription:
      'Investigate scams and protect personal data from phishing and fraud.',
    isLocked: true,
    headerClass: 'phishing',
    pdfLocation: 'assets/pdf/mission5.pdf',
    activity: {
      title: 'Create a Comic',
      description:
        'Write or draw a short comic showing how a phishing scam works—from the fake message to the consequences—and how someone stops it.'
    }
  },
  {
    id: 6,
    title: 'Online Scams',
    discription:
      'Detect fake prizes, jobs, and charity scams while learning safe responses.',
    icon: missionIcons.mission6,
    isLocked: true,
    headerClass: 'scam',
    pdfLocation: 'assets/pdf/mission6.pdf',
    activity: {
      title: 'Scam Spotter Story',
      description:
        'Write a short story about a student who receives a suspicious online message and explain why it is a scam.'
    }
  },
  {
    id: 7,
    title: 'Malware',
    icon: missionIcons.mission7,
    discription:
      ' Identify viruses, worms, and ransomware, and practice prevention with safe habits.',
    isLocked: true,
    headerClass: 'cyberbullying',
    pdfLocation: 'assets/pdf/mission7.pdf',
    activity: {
      title: 'Malware Comic',
      description:
        'Draw a comic showing how a computer virus spreads and what it does to a device.'
    }
  },
  {
    id: 8,
    title: 'Catfishing & Fake Profiles',
    icon: missionIcons.mission8,
    discription:
      'Spot red flags in fake accounts and practice safe online interactions.',
    isLocked: true,
    headerClass: 'ip-digital',
    pdfLocation: 'assets/pdf/mission8.pdf',
    activity: {
      title: 'Red Flag Signals',
      description:
        'Write or draw three warning signs that would make you suspicious of someone online and explain why each one is risky.'
    }
  },
  {
    id: 9,
    title: 'Grooming & Online Predators',
    icon: missionIcons.mission9,
    discription:
      'Recognize grooming tactics, set boundaries, and follow Stop-Save-Tell.',
    isLocked: true,
    headerClass: 'passwords',
    pdfLocation: 'assets/pdf/mission9.pdf',
    activity: {
      title: 'Letter to Myself',
      description:
        'Write a letter to yourself with reminders about what to do if an online interaction ever feels unsafe.'
    }
  },
  {
    id: 10,
    title: 'Social Engineering',
    icon: missionIcons.mission10,
    discription:
      'Learn how hackers use tricks and pressure, and how to resist and report them.',
    isLocked: true,
    headerClass: 'info-identity',
    pdfLocation: 'assets/pdf/mission10.pdf',
    activity: {
      title: 'Safe vs. Unsafe Roleplay',
      description:
        'Roleplay a safe and an unsafe response to a suspicious phone call or message to practice making better choices.'
    }
  },
  {
    id: 11,
    title: 'Extortion',
    icon: missionIcons.mission11,
    discription:
      'Identify threats, refuse demands, and support peers facing online pressure.',
    isLocked: true,
    headerClass: 'phishing',
    pdfLocation: 'assets/pdf/mission11.pdf',
    activity: {
      title: 'Courage Contract',
      description:
        'Write one sentence promising yourself that you will speak up if someone online pressures or threatens you.'
    }
  },
  {
    id: 12,
    title: 'Artificial Intelligence & Deepfakes',
    icon: missionIcons.mission12,
    discription:
      'Understand AI, spot deepfake clues, and practice safe ways to verify content.',
    isLocked: true,
    headerClass: 'scam',
    pdfLocation: 'assets/pdf/mission12.pdf',
    activity: {
      title: 'Truth Check Reminder',
      description:
        'Write one sentence reminding yourself to check whether online videos or images are real before believing or sharing them.'
    }
  }
]

export const getAllMissions = () => {
  return missionsList
}
